import { Injectable } from '@angular/core';
import { Observable, Subject, switchMap } from 'rxjs';
import { ScheduledPaymentsService } from '../payments/scheduled-payments.service';
import { Store } from '@ngxs/store';
import { SettingsState } from '../../components/main/settings/state';
import { take, tap } from 'rxjs/operators';
import { Client, isLoaded } from '@aiwyn/shared';
import { PaymentPlanUi } from '@aiwyn/api';
import { MatTableDataSource } from '@angular/material/table';
import { ConfigState } from '@aiwyn/config';

@Injectable({
  providedIn: 'root'
})
export class PaymentPlanService {
  paymentPlansUpdated$ = new Subject<void>();
  dataSourcePaymentPlans = new MatTableDataSource<PaymentPlanUi>();
  clientList: Client[];
  frequencyOptions = ['WEEKLY', 'BIWEEKLY', 'MONTHLY', 'QUARTERLY', 'YEARLY'];

  // Adapter for existing data management
  paymentPlanMonitor$: Observable<PaymentPlanUi[]> = this.store.select(ConfigState.getBusinessEntitiesStatus).pipe(
    isLoaded(true),
    take(1),
    switchMap(_ => this.store.select(SettingsState.getPaymentPlans)),
    tap(paymentPlans => this.dataSourcePaymentPlans.data = paymentPlans),
  );

  constructor(
    private scheduledPaymentService: ScheduledPaymentsService,
    private readonly store: Store,
  ) {
    this.paymentPlanMonitor$.subscribe();
  }

  /**
   * Checks to see if the saved payment method is associated with any payment plans (recurring payments) or scheduled payments.
   */
  isPaymentMethodUsedByPaymentPlan(id: string): boolean {
    return !!(
      this.dataSourcePaymentPlans.data.find(paymentPlan =>
        (paymentPlan.paymentPlan.paymentMethodId === id && paymentPlan.paymentPlan.active))
        || this.scheduledPaymentService.dataSourceScheduledPayments.data.find(scheduledPaymentUi =>
        (scheduledPaymentUi.actionDefInstanceDTO.action.paymentMethodId === id && ['STAGED', 'DECLINED'].includes(scheduledPaymentUi.actionDefInstanceDTO.status)))
    );
  }
}
